import { CardBackground, Typography } from "@hellocarbo/lasagne";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { data, useFetcher } from "react-router";

import { TOnboarding } from "@/types";

import Actions from "./Actions";
import ViewAllActionsModal from "./ViewAllActionsModal";

export async function loader() {
  const scoresResponse = await fetch(`/api/client/onboardings/`);

  if (scoresResponse.status == 403) {
    return { error: "No actions available" };
  }

  if (scoresResponse.status !== 200) {
    throw data("Failed to load onboarding actions", {
      status: scoresResponse.status,
    });
  }

  const { data: onboarding } = (await scoresResponse.json()) as {
    data: TOnboarding;
  };

  return {
    progressData: onboarding,
    currentStep: onboarding.current_step,
    allActionsBySteps: onboarding.all_actions,
    trackingCampaignId: onboarding.tracking_campaign_id,
    scoreId: onboarding.id,
    reviewId: onboarding.review_id,
    allActionsDone: onboarding.all_actions_done,
  };
}

const OnboardingActionsSection = () => {
  const { t } = useTranslation("onboarding");
  const fetcher = useFetcher();
  useEffect(() => {
    fetcher.submit({}, { action: "/onboarding/action-data", method: "get" });
  }, []);

  if (
    fetcher.data?.allActionsDone ||
    fetcher.data?.error === "No actions available"
  ) {
    return null;
  }

  return (
    <CardBackground className="col-span-3 lg:col-span-2">
      <div className="flex items-baseline justify-between">
        <Typography step="2" as="h2" weight="bold" className="mb-sm">
          {t("actions.title")}
        </Typography>
        <ViewAllActionsModal
          allActionsBySteps={fetcher.data?.allActionsBySteps}
          trackingCampaignId={fetcher.data?.trackingCampaignId}
          scoreId={fetcher.data?.scoreId}
          reviewId={fetcher.data?.reviewId}
        />
      </div>

      <Actions
        currentStep={fetcher.data?.currentStep}
        trackingCampaignId={fetcher.data?.trackingCampaignId}
        scoreId={fetcher.data?.scoreId}
        reviewId={fetcher.data?.reviewId}
      />
    </CardBackground>
  );
};

export default OnboardingActionsSection;
